// extracted by mini-css-extract-plugin
module.exports = {"copyModalTitle":"CopyParams_copyModalTitle__G1h36","copyModalContent":"CopyParams_copyModalContent__EJfQ_"};